import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getInstitution } from '../../config/institutionConfig';

const AdminLogin = () => {
  const history = useHistory();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  const institution = getInstitution();
  const colors = institution.colors;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Si ya hay sesión, ir directo al panel.
  if (isAuthenticated()) {
    const destino = location.state?.from?.pathname || '/admin';
    history.replace(destino);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      const destino = location.state?.from?.pathname || '/admin';
      history.replace(destino);
    } catch (err) {
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
          {/* Cabecera con identidad institucional */}
          <div
            className="px-8 py-8 text-center"
            style={{
              background: `linear-gradient(135deg, ${colors.headerGradientStart}, ${colors.headerGradientMid}, ${colors.headerGradientEnd})`,
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}${institution.logo}`}
              alt={`Logo ${institution.shortName}`}
              className="h-14 mx-auto mb-3 drop-shadow"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h1 className="text-xl font-bold text-white">Panel de Administración</h1>
            <p className="text-white/80 text-sm mt-1">{institution.shortName}</p>
          </div>

          {/* Formulario */}
          <form onSubmit={handleSubmit} className="px-8 py-8 space-y-5">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg px-4 py-3">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Correo electrónico</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                style={{ '--tw-ring-color': colors.primary }}
                placeholder="admin@iush.edu.co"
                autoComplete="username"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">Contraseña</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent"
                style={{ '--tw-ring-color': colors.primary }}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 text-white font-semibold rounded-lg transition-all hover:opacity-90 disabled:opacity-60 shadow-md"
              style={{ background: `linear-gradient(135deg, ${colors.accentFrom}, ${colors.accentTo})` }}
            >
              {loading ? 'Ingresando...' : 'Iniciar sesión'}
            </button>
          </form>
        </div>

        <p className="text-center text-gray-400 text-xs mt-6">
          © {new Date().getFullYear()} {institution.name}
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
